var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.5249L11.25 12.4199",
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.5249L15.75 12.4199",
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 7.24512H23.625V7.24512C22.3394 7.24512 21.6965 7.24512 21.2218 7.52966C20.9397 7.69875 20.7036 7.9348 20.5345 8.21691C20.25 8.69164 20.25 9.33447 20.25 10.6201V16.7001C20.25 18.5857 20.25 19.5285 19.6642 20.1143C19.0784 20.7001 18.1356 20.7001 16.25 20.7001H10.75C8.86438 20.7001 7.92157 20.7001 7.33579 20.1143C6.75 19.5285 6.75 18.5857 6.75 16.7001V10.6201C6.75 9.33447 6.75 8.69164 6.46546 8.21691C6.29637 7.9348 6.06031 7.69875 5.77821 7.52966C5.30347 7.24512 4.66065 7.24512 3.375 7.24512V7.24512Z",
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3267 3.48854C11.4549 3.3785 11.7373 3.28127 12.1303 3.21192C12.5232 3.14257 13.0047 3.10498 13.5 3.10498C13.9953 3.10498 14.4768 3.14257 14.8697 3.21192C15.2627 3.28127 15.5451 3.3785 15.6733 3.48854",
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fe3cc86c2fea5aaf8a6cf5b37c91d5ab.svg";
export { ForwardRef as ReactComponent };